import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PlanoDeContasService } from '../../../services/plano-de-contas.service';
import { SpinnerService } from '../../../services/spinner.service';
import { ToastService } from '../../../services/toast.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { Icones } from '../../../shared/variaveisDeRotas';

@Component({
    selector: 'app-plano-de-conta-adicionar',
    templateUrl: './plano-de-contas-adicionar.component.html',
    styleUrl: './plano-de-contas-adicionar.component.scss',
})


export class PlanoDeContasAdicionarComponent implements OnInit {

    @Output() tituloChange = new EventEmitter<string>();
    @Output() iconeChange = new EventEmitter<string>();

    contaContabilPaiId: any;
    usuarioId: any;

    tiposTransacao = [
        { label: 'Débito', value: 1 },
        { label: 'Crédito', value: 2 }
    ];


    criarContaContabil: FormGroup = new FormGroup({
        codigo: new FormControl(''),
        descricao: new FormControl('', Validators.required),
        tipo: new FormControl(0),
        contaSuperior: new FormControl(''),
        nivel: new FormControl(0),
        tipoTransacaoSaldoAnteriorCadastro: new FormControl(this.tiposTransacao),
        natureza: new FormControl(0),
        saldo: new FormControl(0),
        maiorNivel: new FormControl(false),
        usuarioId: new FormControl(null),
    });

    constructor(
        private route: ActivatedRoute,
        private planoDeContasService: PlanoDeContasService,
        public spinnerService: SpinnerService,
        private toastService: ToastService,
        private router: Router,
        private jwtHelper: JwtHelper
    ) { }

    ngOnInit(): void {
        this.tituloChange.emit('Adicionar Conta Contábil');
        this.iconeChange.emit(Icones.carteiraAmarelo);

        this.route.params.subscribe(params => { this.contaContabilPaiId = params['id']; });
        this.route.params.subscribe(params => { this.usuarioId = params['usuarioId']; });

        this.spinnerService.show('Validando obrigatoriedades...');
        this.planoDeContasService.validarObrigatoriedadesContaContabilSelecionada(this.contaContabilPaiId, this.usuarioId).subscribe({
            next: (res) => {
                this.criarContaContabil.get('codigo').setValue(res.codigo);
                this.criarContaContabil.get('tipo').setValue(res.tipo);
                this.criarContaContabil.get('contaSuperior').setValue(res.contaSuperior);
                this.criarContaContabil.get('nivel').setValue(res.nivel);
                this.criarContaContabil.get('natureza').setValue(res.natureza);
                this.criarContaContabil.get('usuarioId').setValue(this.jwtHelper.getUserIdFromToken());
                this.spinnerService.hide();
            },
            error: (e) => {
                this.toastService.setMensagemToast(`Erro ao carregar plano de contas: ${e.error}`, SeveridadeToast.Error);
                this.spinnerService.hide();
            }
        })
    }

    onSubmit(): void {
        this.spinnerService.show('Criando conta contábil...');
        this.planoDeContasService.addContaContabil(this.criarContaContabil.getRawValue()).subscribe({
            next: (res) => {
                this.toastService.setMensagemToast('Conta contábil adicionada com sucesso!', SeveridadeToast.Success);
                this.router.navigate(['plano-de-contas']);
                this.spinnerService.hide();
            },
            error: (e) => {
                this.toastService.setMensagemToast(`Erro ao adicionar conta contábil: ${e.error}`, SeveridadeToast.Error);
                this.spinnerService.hide();
            }
        })
    }

    onCancel(): void {
        this.router.navigate(['plano-de-contas']);
    }
}
